import { useTranslation } from 'react-i18next';
import { CandidatesTablePrework } from '../CandidatesTablePrework';
import { useCreateGroupPrework } from '../CreateGroupPage/useCreateGroup';
import { useEditGroupPreWork } from '../EditGroupPage/useEditGroup';
import { useSnapshot } from 'valtio';
import { CandidatesBatchState } from '../CreateGroupPage/CandidatesList.store';

export const AddMoreCandidatesContainersPrework = () => {
	const { t } = useTranslation();
	const { group } = useEditGroupPreWork();
	const groupName = group?.preworkGroupName;
	const {
		candidatesList,
		onCandidatesPageChange,
		onCandidateFilterChange,
		candidatesFilter,
		candidatePaging,
		onCreateGroupClick,
	} = useCreateGroupPrework();
	const candidateBatchSnap = useSnapshot(CandidatesBatchState);
	const batchIdInSnap = candidateBatchSnap.selectedBatch?.id;

	const existingCandidatesIds = group?.preworkGroupMembers.map(
		(prework) => prework.applicationId
	);
	const existingCandidatesCount = existingCandidatesIds?.length;

	return (
		<div className="p-8">
			<h2>
				{t('addMoreCandidatesToGroup', { groupName, existingCandidatesCount })}
			</h2>
			<CandidatesTablePrework
				data={candidatesList}
				onCandidatesPageChange={onCandidatesPageChange}
				candidatePageConfig={candidatePaging}
				candidatesFilter={candidatesFilter}
				onCandidateFilterChange={onCandidateFilterChange}
				existingCandidatesIdsForAddMore={existingCandidatesIds}
				onCreateGroupClick={onCreateGroupClick}
				selectedBatchId={batchIdInSnap}
			/>
		</div>
	);
};
